import React from "react"
import { useEffect } from "react"
import PubSub from "pubsub-js"
import Value from "aldoo-ra/Value"
import config from "aldoo-ra/Config"

// The UET base tag is injected by AldooVike Head when MICROSOFT_UET_ID is set;
// this component only feeds it conversion events and the enhanced-conversions
// email. Event actions are per project (config.MICROSOFT_UET_EVENTS) so several
// sites can share one tag with separate goals.
const { MICROSOFT_UET_ID, MICROSOFT_UET_EVENTS } = config
const EVENTS = { purchase: "purchase", subscribe: "subscribe", ...(MICROSOFT_UET_EVENTS || {}) }

const uet = (...args) => {
  window.uetq = window.uetq || []
  window.uetq.push(...args)
}

// Accepts both payload shapes in use: the Store's GA4-style
// { value, currency, items, transactionId } and the simpler
// { price, currency, pid }. Stripe reports lowercase ISO codes; UET expects uppercase.
const conversionParams = (data) => ({
  event_label: data.pid ?? data.items?.[0]?.item_id ?? "",
  revenue_value: data.value ?? data.price ?? 0,
  currency: (data.currency || "").toUpperCase(),
})

// The Store flags subscriptions with subscriptionId (the transaction id is
// usually the payment intent even for subscriptions); fall back to Stripe's
// "sub_" prefix for other publishers.
const isSubscription = (data) =>
  Boolean(data.subscriptionId) || /^sub_/.test(data.transaction_id || data.transactionId || "")

export default function MicrosoftTracking({ children }) {
  const [userProfile] = Value("user-profile")

  //---------------------------------------------
  // Enhanced conversions: hashed by UET, must be set before the event
  //---------------------------------------------
  useEffect(() => {
    if (!MICROSOFT_UET_ID) return
    if (!userProfile?.email) return
    uet("set", { pid: { em: userProfile.email } })
  }, [userProfile?.email])

  useEffect(() => {
    if (!MICROSOFT_UET_ID) return
    // Page views: handled by the base tag (enableAutoSpaTracking)

    const subscribed = PubSub.subscribe("Tracking_Subscribed", (_, data) => {
      uet("event", EVENTS.subscribe, conversionParams(data))
    })
    const purchased = PubSub.subscribe("Tracking_Purchase", (_, data) => {
      uet("event", isSubscription(data) ? EVENTS.subscribe : EVENTS.purchase, conversionParams(data))
    })
    return () => {
      PubSub.unsubscribe(subscribed)
      PubSub.unsubscribe(purchased)
    }
  }, [])

  return children || null
}
